import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';

enum rowSelectionEnum {
  SINGLE = 'single',
  MULTIPLE = 'multiple'
}

@Component({
  selector: 'app-ag-grid-wrapper',
  templateUrl: './ag-grid-wrapper.component.html',
  styleUrls: ['./ag-grid-wrapper.component.scss']
})
export class AgGridWrapperComponent implements OnInit {



  @Input() columnDefs: any[] = [];
  @Input() rowData: any[] = [];
  @Input() gridConfig: any = {};
  @Input() gridHeight!: number;
  @Input() gridWidth: any;
  @Input() globalSearchText: string = '';
  @Input() frameworkComponents: any;
  @Input() context: any;
  @Input() rowClassRules = {};


  @Output() gridReady: EventEmitter<any> = new EventEmitter();
  @Output() rowDataLoad: EventEmitter<any> = new EventEmitter();
  @Output() selectionChanged: EventEmitter<any> = new EventEmitter();
  @Output() rowSelected: EventEmitter<any> = new EventEmitter();
  @Output() columnGroupOpened: EventEmitter<any> = new EventEmitter();
  @Output() cellValueChanged: EventEmitter<any> = new EventEmitter();

  public gridApi: any;
  public gridColumnApi: any;
  public gridOptions: any;

  constructor() {
    // this.gridHeight = window.innerHeight - 300;
    this.gridWidth = '100%';
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['gridConfig']?.currentValue) {
      this.setgridConfig();
      if (this.gridApi) {
        this.getGridData();
      }
    }
    if (changes['globalSearchText']?.currentValue) {
      this.onGlobalSearch();
    }
  }

  private setgridConfig(): void {
    this.gridOptions = {
      defaultColDef: this.gridConfig.defaultColDef || {},
      suppressContextMenu: this.gridConfig.suppressContextMenu === undefined ? false : this.gridConfig.suppressContextMenu,
      suppressMenuHide: this.gridConfig.suppressMenuHide === undefined ? false : this.gridConfig.suppressMenuHide,
      sideBar: this.gridConfig.sideBar === undefined ? "true" : this.gridConfig.sideBar,
      rowGroupPanelShow: this.gridConfig.rowGroupPanelShow === undefined ? 'always' : this.gridConfig.rowGroupPanelShow,
      headerHeight: this.gridConfig.headerHeight === undefined ? 40 : this.gridConfig.headerHeight,
      pagination: this.gridConfig.pagination === undefined ? true : this.gridConfig.pagination,
      paginationPageSize: this.gridConfig.paginationPageSize === undefined ? 15 : this.gridConfig.paginationPageSize,
      rowSelection: this.gridConfig.rowSelection === undefined ? 'multiple' : this.gridConfig.rowSelection,
      suppressCellSelection: this.gridConfig.suppressCellSelection === undefined ? true : this.gridConfig.suppressCellSelection,
      rowClassRules: Object.assign(this.rowClassRules, { 'rag-modified': this.checkIfModified }),
      overlayNoRowsTemplate: this.gridConfig.overlayNoRowsTemplate === undefined ? 'No results found.' : this.gridConfig.overlayNoRowsTemplate,
      enableCellTextSelection : true,
      domLayout: 'autoHeight'
    };
    if (this.frameworkComponents) {
      this.gridOptions['frameworkComponents'] = this.frameworkComponents;
    }
    if (this.context) {
      this.gridOptions['context'] = this.context;
    }
  }

  private checkIfModified(params: any) {
    return params.data ? params.data.isModified : false;
  }

  private getGridData(): void {
    // this.gridApi.showLoadingOverlay();
    // if(this.gridConfig.fetchUrl) { 
    // if (this.gridConfig.fetchUrl.indexOf('/zip') === -1) {
    this.gridApi.setRowData(this.rowData);
    // } 
    // }
  }

  private onGlobalSearch(): void {
    this.gridApi.setQuickFilter(this.globalSearchText);
  }

  public onGridReady(params: any): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridReady.emit();
    // this.autoSizeAll(false);
  }

  autoSizeAll(skipHeader: boolean) {
    setTimeout(() => {
      const allColumnIds: string[] = [];
      this.gridColumnApi.getAllColumns()!.forEach((column: any) => {
        allColumnIds.push(column.getId());
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }, 200);

  }

  public setRowData(): void {
    this.gridApi.setRowData(this.rowData);
  }

  public onRowSelected(params: any): void {
    this.rowSelected.emit(params);
  }

  public onRowDataLoad(params: any): void {
    this.rowDataLoad.emit(params);
  }

  public onSelectionChanged(params: any): void {
    this.selectionChanged.emit(params);
  }

  public onColumnGroupOpened(params: any): void {
    this.gridApi.sizeColumnsToFit();
  }

  public addRows(rows: any, index?: number) {
    if (this.gridConfig?.pagination) {
      this.gridApi.paginationGoToFirstPage();
    }
    this.gridApi.updateRowData({
      addIndex: index || 0,
      add: rows
    });
  }

  public resetAllFilters() {
    this.gridApi.setFilterModel(null);
    this.gridApi.setSortModel(null);
  }

  public getSelectedData() {
    return this.gridApi?.getSelectedRows();
  }

  public getRenderedData() {
    const renderedNodes: any[] = [];
    this.gridApi.forEachNode((node: any) => {
      renderedNodes.push(node.data);
    });
    return renderedNodes;
  }

  public removeRows(rows: any[]) {
    this.gridApi.updateRowData({
      remove: rows
    });
    this.gridApi.refreshCells();
  }

  public getGridApi() {
    return this.gridApi;
  }

  public onCellValueChanged(params: any): void {
    this.gridApi.redrawRows({
      rowNodes: [params.node]
    });
    this.cellValueChanged.emit(params);
  }

  public getModifiedData() {
    const modifiedData: any[] = [];
    this.gridApi.forEachLeafNode((node: any) => {
      if (node.data.isModified) {
        modifiedData.push(node.data);
      }
    });
    return modifiedData;
  }

}
